<app-settings-card
  heading="Archivordner"
  description="Organisiere deine Dokumente mithilfe von Ordner. Nur leere Ordner können gelöscht werden."
  [showSaveButton]="false"
  [disabled]="disabled"
>
  @if (folders.length > 0) {
    <div class="mt-4 overflow-hidden rounded-md border border-edge bg-surface">
      <ul
        role="list"
        class="divide-y divide-separator"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
      >
        @for (folder of folders; track folder) {
          <li
            class="flex justify-between items-center"
            [class.italic]="!folder.active"
            [class.text-fg-muted]="!folder.active"
            [class.bg-surface-hover]="!folder.active"
            cdkDrag
            cdkDragLockAxis="y"
          >
            <div class="px-6 py-4 w-full flex flex-row justify-between items-center">
              <div>
                @if (folder.id !== editId) {
                  <p>
                    {{ folder.name }}
                  </p>
                }
                @if (folder.id === editId) {
                  <app-input style="margin: -10px; min-width: 100%" class="block"
                    ><input
                      appTailwindInput
                      type="text"
                      [(ngModel)]="folder.name"
                      (blur)="editFolder(null)"
                      autofocus
                  /></app-input>
                }
              </div>
              @if (folder.documentCount > 0) {
                <div class="text-fg-primary text-xs mr-4">
                  {{ folder.documentCount }}
                  <span class="text-fg-muted">{{
                    folder.documentCount === 1 ? 'Dokument' : 'Dokumente'
                  }}</span>
                </div>
              }
            </div>
            @if (!disabled) {
              <app-dropdown-minimal-menu>
                <app-dropdown-button>
                  <app-ng-icon
                    name="heroEllipsisVerticalSolid"
                    class="text-3xl"
                    strokeWidth="3"
                  ></app-ng-icon>
                </app-dropdown-button>
                <app-dropdown-item (menuClick)="editFolder(folder.id)">
                  Umbennen
                </app-dropdown-item>
                @if (folder.documentCount === 0) {
                  <app-dropdown-item (menuClick)="deleteFolder(folder.id)">
                    Löschen
                  </app-dropdown-item>
                }
                @if (folder.active) {
                  <app-dropdown-item (menuClick)="folderState(folder.id, false)">
                    Ausblenden
                  </app-dropdown-item>
                }
                @if (!folder.active) {
                  <app-dropdown-item (menuClick)="folderState(folder.id, false)">
                    Einblenden
                  </app-dropdown-item>
                }
              </app-dropdown-minimal-menu>
            }
          </li>
        }
      </ul>
    </div>
  }
  <button
    appTailwindButton
    (click)="addNewFolder()"
    color="white"
    [size]="'xs'"
    class="mt-2"
    [disabled]="disabled"
  >
    Ordner erstellen
  </button>
</app-settings-card>
